import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

// INTERFACES
import { OptionInterface } from '../../../shared/interfaces/common.interface';
import { trackByValue } from '../../../shared/util';

@Component({
  selector: 'lum-filter-multiselect-chips',
  templateUrl: './filter-multiselect-chips.component.html',
  styleUrls: ['./filter-multiselect-chips.component.scss'],
})
export class FilterMultiselectChipsComponent implements OnInit {
  @Input()
  selectedOptions :any[] = [];

  @Input()
  options :OptionInterface[] = [];

  @Input()
  placeholder :string = '';

  @Input()
  inlineChips :boolean = false;

  @Output()
  selectOptionEvent :EventEmitter<any> = new EventEmitter<any>();

  optionForm = new UntypedFormControl([]);
  trackByValue = trackByValue;

  constructor() {}

  ngOnInit() :void {}

  ngOnChanges({ options, selectedOptions } :SimpleChanges) :void {
    const items :OptionInterface[] = [];
    if (
      (options?.currentValue?.length > 0 ||
        selectedOptions?.currentValue.length > 0) &&
      this.selectedOptions?.length > 0
    ) {
      this.selectedOptions.forEach((opt) => {
        let selectedOption = null;
        if (typeof opt === 'number') {
          selectedOption = this.options.find((option) => option.value === opt);
        } else {
          selectedOption = this.options.find(
            (option) => option?.value?.id === opt?.id,
          );
        }
        if (selectedOption) {
          items.push(selectedOption);
        }
      });
    }

    this.optionForm.setValue(items);
  }

  remove(item :any) :void {
    const items = this.optionForm.value as OptionInterface[];
    const array = this.removeFirst(items, item);
    this.optionForm.setValue(['']);
    this.optionForm.setValue(array);
    this.onSelectionChange();
  }

  private removeFirst<T>(array :T[], toRemove :T) :T[] {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }

    return array;
  }

  onSelectionChange() :void {
    const ids = this.optionForm.value.map(
      (option :OptionInterface) => option.value,
    );
    this.selectOptionEvent.emit(ids);
  }
}
